module.exports = __webpack_public_path__ + "img/doctor_certificate1.c47890ae.jpg";